import { dataEyeSlashSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconEyeSlashSolid = /*#__PURE__*/createIcon(dataEyeSlashSolid)
export default IconEyeSlashSolid
